import { create } from 'zustand';
import dayjs from "dayjs";

import { apiDomain, basename } from '../setting';
import useAuthAdminStore from './useAuthAdminStore';
import useLoadingStore from './useLoadingStore';

const useAdminApplicationStore = create((set, get) => ({
    isFilterOpen: false,
    setIsFilterOpen: (value) => set((state) => {
        return { isFilterOpen: value }
    }),

    filter_status: undefined,
    setFilterStatus: (value) => set((state) => {
        return { filter_status: value }
    }),

    flowTypeList: [
        { label: "LOG", value: "LOG" },
        { label: "PCA", value: "PCA" },
        { label: "Change To PCA", value: "CHGTOPCA" },
    ],
    filter_flowType: undefined,
    setFilterFlowType: (value) => set((state) => {
        return { filter_flowType: value }
    }),

    filter_from_date: "",
    setFilterFromDate: (value) => set((state) => {
        return { filter_from_date: value }
    }),

    filter_to_date: "",
    setFilterToDate: (value) => set((state) => {
        return { filter_to_date: value }
    }),

    filter_user: [],
    setFilterUser: (value) => set((state) => {
        return { filter_user: value }
    }),

    isSortingOpen: false,
    setIsSortingOpen: (value) => set((state) => {
        return { isSortingOpen: value }
    }),

    selectedTab: 'NEWREQ',
    setSelectedTab: (value) => set((state) => {
        return { selectedTab: value }
    }),

    searchText: "",
    setSearchText: (value) => set((state) => {
        return { searchText: value }
    }),

    sort: "submitdt desc",
    setSort: (value) => set((state) => {
        return { sort: value }
    }),

    page: 1,
    setPage: (value) => set((state) => {
        return { page: value }
    }),

    recordperpage: 10,
    setRecordPerPage: (value) => set((state) => {
        return { recordperpage: value }
    }),

    ttlpage: null,
    NEWREQCount: "",
    SUPPLECount: "",
    REVIEWCount: "",
    APPROVEDCount: "",
    CLAIMCount: "",
    STPCount: "",
    AllCount: "",
    CANCELLEDCount: "",
    applicationList: [],

    admListPreAuthForm: async () => {
        const { selectedTab, searchText, sort, page, recordperpage } = get();
        const { token, logout } = useAuthAdminStore.getState();
        const { setLoading } = useLoadingStore.getState();
        const { filter_status, filter_flowType, filter_from_date, filter_to_date, filter_user } = get();

        const response = await fetch(`${apiDomain}/${basename}/api/preauthAdmin/admListPreAuthForm`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                "showtab": selectedTab,
                "searchs": "",
                "searchsor": {
                    "fullname": searchText,
                    "refno": searchText,
                    "IDPLNO": searchText,
                    "IDINSN": searchText,
                },
                "sort": sort,
                "recordperpage": recordperpage,
                "page": page,
                "intstatus": filter_status ?? "",
                "flowtype": filter_flowType ?? "",
                "submitdtfrom": filter_from_date,
                "submitdtto": filter_to_date,
                "staffId": filter_user.join(",")
            })
        });

        if (response.status === 401) { // Unauthorized
            logout();
            setLoading(false);
            throw new Error('Unauthorized');
        }

        if (!response.ok) {
            setLoading(false);
            throw new Error('Network Error');
        }

        const data = await response.json();

        set({
            applicationList: data.list.records,
            ttlpage: data.list.ttlpage,
            NEWREQCount: data.NEWREQCount,
            SUPPLECount: data.SUPPLECount,
            REVIEWCount: data.REVIEWCount,
            APPROVEDCount: data.APPROVEDCount,
            CLAIMCount: data.CLAIMCount,
            STPCount: data.STPCount,
            AllCount: data.AllCount,
            CANCELLEDCount: data.CANCELLEDCount,
        });
    },
    loadImage: async (id) => {
        const { token } = useAuthAdminStore.getState();

        const response = await fetch(`${apiDomain}/${basename}/api/general/admdownload/${id}?isthumb=squ`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`
            },
        });

        const data = await response.json();

        return data;
    },

    assignStaffList: [],
    getPreAuthStaff: async () => {
        const { token, logout } = useAuthAdminStore.getState();
        const { setLoading } = useLoadingStore.getState();

        const response = await fetch(`${apiDomain}/${basename}/api/preAuthAdmin/getPreAuthStaff?handleronly=Y`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        if (response.status === 401) { // Unauthorized
            logout();
            setLoading(false);
            throw new Error('Unauthorized');
        }

        if (!response.ok) {
            setLoading(false);
            throw new Error('Network Error');
        }

        const data = await response.json();

        set({
            assignStaffList: data.staffs,
        });
    },

    internalRemark: "",
    setInternalRemark: (value) => set((state) => {
        return { internalRemark: value }
    }),

    admUptPreAutFrmIntRmk: async (aid) => {
        const { internalRemark } = get();
        const { token, logout } = useAuthAdminStore.getState();
        const { setLoading } = useLoadingStore.getState();

        const response = await fetch(`${apiDomain}/${basename}/api/preauthAdmin/admUptPreAutFrmIntRmk`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                "aid": aid,
                "intrmk": internalRemark
            })
        });

        if (response.status === 401) { // Unauthorized
            logout();
            setLoading(false);
            throw new Error('Unauthorized');
        }

        if (!response.ok) {
            setLoading(false);
            throw new Error('Network Error');
        }
    },


    assignStaffToPreAuthForm: async (refno, staffid) => {
        const { token, logout } = useAuthAdminStore.getState();
        const { setLoading } = useLoadingStore.getState();

        const response = await fetch(`${apiDomain}/${basename}/api/preauthAdmin/assignStaffToPreAuthForm`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                "aid": refno,
                "staffId": staffid
            })
        });

        if (response.status === 401) { // Unauthorized
            logout();
            setLoading(false);
            throw new Error('Unauthorized');
        }

        if (!response.ok) {
            setLoading(false);
            throw new Error('Network Error');
        }
    },

    admListPreAuthFormToExcel: async () => {
        const { token, logout } = useAuthAdminStore.getState();
        const { setLoading } = useLoadingStore.getState();
        const { selectedTab, searchText } = get();
        const { filter_status, filter_flowType, filter_from_date, filter_to_date, filter_user, sort } = get();

        const response = await fetch(`${apiDomain}/${basename}/api/preAuthAdmin/admListPreAuthFormToExcel`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                "showtab": selectedTab,
                "searchs": "",
                "searchsor": {
                    "fullname": searchText,
                    "refno": searchText,
                },
                "intstatus": filter_status ?? "",
                "flowtype": filter_flowType ?? "",
                "submitdtfrom": filter_from_date,
                "submitdtto": filter_to_date,
                "staffId": filter_user.join(","),
                "sort": sort,
            })
        });

        if (response.status === 401) { // Unauthorized
            logout();
            setLoading(false);
            throw new Error('Unauthorized');
        }

        if (!response.ok) {
            setLoading(false);
            throw new Error('Network Error');
        }

        const data = await response.json();
        return data?.url;
    },
}))

export default useAdminApplicationStore;